export class CorePermissions {
  public static APP_ADMIN = 'App:Administration';
  public static APP_USER = 'App:User';

  public static USER_READ = 'User:Management:Read';
  public static USER_CREATION = 'User:Management:Creation';
  public static USER_UPDATE = 'User:Management:Update';
  public static USER_DELETE = 'User:Management:Delete';
  public static ADMIN_CREATION = 'Admin:Management:Creation';
  public static ADMIN_UPDATE = 'Admin:Management:Update';
  public static ADMIN_DELETE = 'Admin:Management:Delete';

  public static ADMIN_CONFIGURATION_VIEW = 'Admin:Configuration:View';
  public static ADMIN_CONFIGURATION_CREATE = 'Admin:Configuration:Create';
  public static ADMIN_CONFIGURATION_UPDATE = 'Admin:Configuration:Update';
  public static ADMIN_CONFIGURATION_DELETE = 'Admin:Configuration:Delete';

  public static CONTENT_MANAGEMENT_VIEW_LIST = 'Content:Management:ViewList';
  public static CONTENT_MANAGEMENT_VIEW_DETAIL = 'Content:Management:ViewDetail';
  public static CONTENT_MANAGEMENT_CREATE = 'Content:Management:Create';
  public static CONTENT_MANAGEMENT_UPDATE = 'Content:Management:Update';
  public static CONTENT_MANAGEMENT_DELETE = 'Content:Management:Delete';

  public static GROUP_MANAGEMENT_VIEW = 'Group:Management:View';
  public static GROUP_MANAGEMENT_CREATE = 'Group:Management:Create';
  public static GROUP_MANAGEMENT_UPDATE = 'Group:Management:Update';
  public static GROUP_MANAGEMENT_DELETE = 'Group:Management:Delete';

  public static TENANT_MANAGEMENT_READ = 'Tenant:Management:Read';
  public static TENANT_MANAGEMENT_WRITE = 'Tenant:Management:Write';
}
